<template><div></div> </template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Logout',
  methods: {
    ...mapActions(['signOutOidc'])
  },
  mounted() {
    this.signOutOidc()
  }
}
</script>
